import React from "react";
import PrintField from "../../shared/PrintField";
import "./InvitationEGM_EN.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

const InvitationEGM_EN = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      <div className="inv-paper inv-en" ref={ref}>
        {/* Company (top-right) */}
        <div className="en-top-right">
          <InputField className="en-input long" />
           Co., Ltd
        </div>

        {/* date (center) */}
        <div className="en-date-center">
          <InputField className="en-input long" />date
        </div>

        {/* Subject */}
        <div className="en-row">
          <div className="en-col-label en-bold">Subject:</div>
          <div className="en-col-text en-bold">
            Invitation to attend the Extraordinary General Meeting of Shareholders No
            <InputField className="en-input small" />/<InputField className="en-input small" />
          </div>
        </div>

        {/* To */}
        <div className="en-row">
          <div className="en-col-label en-bold">To:</div>
          <div className="en-col-text en-bold">All Shareholders of the Company</div>
        </div>

        {/* Body paragraph 1 */}
        <p className="en-paragraph">
          Notice is hereby given that the Extraordinary General Meeting of Shareholders 
          <br/>No<InputField className="en-input small" />/<InputField className="en-input small" /> of the Company will be held on
          <InputField className="en-input long" /> at <InputField className="en-input time" /> a.m. at No.
          <InputField className="en-input long" />
        </p>

        {/* line */}
        <p className="en-paragraph">
          The purpose of the Meeting is to consider the following agenda:
        </p>

        {/* Agenda list */}
        <div className="en-agenda">
          <div className="en-ag-row">
            <div className="en-ag-left en-bold">Agenda 1</div>
            <div className="en-ag-right">
              To consider and adopt the Minutes of the Annual General Meeting of Shareholders 
              <br/>No.
              <InputField className="en-input small" />/<InputField className="en-input small" /> held on
              <InputField className="en-input tiny" />
            </div>
          </div>

          <div className="en-ag-row">
            <div className="en-ag-left en-bold">Agenda 2</div>
            <div className="en-ag-right">To consider and vote to dissolve the Company;</div>
          </div>

          <div className="en-ag-row">
            <div className="en-ag-left en-bold">Agenda 3</div>
            <div className="en-ag-right">To consider the appointment of a liquidator;</div>
          </div>

          <div className="en-ag-row">
            <div className="en-ag-left en-bold">Agenda 4</div>
            <div className="en-ag-right">
              To consider the appointment of an auditor and his/her remuneration;
            </div>
          </div>

          <div className="en-ag-row">
            <div className="en-ag-left en-bold">Agenda 5</div>
            <div className="en-ag-right">To consider any other business (if any)</div>
          </div>
        </div>

        {/* Bottom paragraph */}
        <p className="en-paragraph en-bottom">
          Kindly attend the meeting on the date and at the time and place mentioned above. If you
          wish to appoint a person to attend and vote at the Meeting on your behalf, please
          complete and duly execute the attached proxy. The completed and executed proxy must be
          deposited with the Chairperson of the Meeting at or before the commencement of the
          Meeting.
        </p>
      </div>
    </div>
  );
});

export default InvitationEGM_EN;
